import { PropType } from '@vue/runtime-dom';
import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'WizardStepper',
  props: {
    disabledSteps: {
      type: Object as PropType<number[]>,
      required: false,
    },
  },
})
export default class WizardStepper extends Vue {
  disabledSteps?: number[];

  get disabledClasses() {
    // disabling a step is made through css because element ui stepper doesn't have a prop to show a step disabled
    return this.disabledSteps?.map((x) => `step-${x}-disable`).join(' ');
  }
}
